import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export function initStartupGauge(): void {
    const needle = document.querySelector('.speed-gauge__needle');
    if (!needle) return;

    gsap.fromTo(needle, 
        { rotate: 0 }, 
        { 
            rotate: 120, 
            duration: 2, 
            ease: 'elastic.out(1, 0.3)',
            scrollTrigger: {
                trigger: '.speed-gauge',
                start: 'top 80%'
            }
        }
    );
}

export function initLaunchpadTimeline(): void {
    const steps = Array.from(document.querySelectorAll<HTMLElement>('.launch-step'));
    if (steps.length === 0) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const desktopLayout = window.matchMedia('(min-width: 641px)').matches;
    const cards = steps
        .map(step => step.querySelector<HTMLElement>('.launch-step__card'))
        .filter((card): card is HTMLElement => Boolean(card));
    const dots = steps
        .map(step => step.querySelector<HTMLElement>('.launch-step__dot'))
        .filter((dot): dot is HTMLElement => Boolean(dot));

    if (prefersReducedMotion) {
        gsap.set([...cards, ...dots], { clearProps: 'all' });
        return;
    }

    cards.forEach((card, index) => {
        gsap.set(card, {
            autoAlpha: 0,
            x: desktopLayout ? (index % 2 === 0 ? -72 : 72) : 36
        });
    });
    gsap.set(dots, { autoAlpha: 0, scale: 0.6 });

    const timeline = gsap.timeline({
        paused: true,
        onComplete: () => {
            gsap.set([...cards, ...dots], { clearProps: 'opacity,visibility,transform' });
        }
    });

    steps.forEach((step, index) => {
        const card = step.querySelector<HTMLElement>('.launch-step__card');
        const dot = step.querySelector<HTMLElement>('.launch-step__dot');
        if (!card) return;

        const at = index === 0 ? 0 : '>-0.06';
        timeline.to(card, {
            autoAlpha: 1,
            x: 0,
            duration: 0.7,
            ease: 'power3.out'
        }, at);

        if (dot) {
            timeline.to(dot, {
                autoAlpha: 1,
                scale: 1,
                duration: 0.34,
                ease: 'back.out(2)'
            }, '<0.12');
        }
    });

    ScrollTrigger.create({
        trigger: '.launchpad-timeline',
        start: 'top 74%',
        once: true,
        onEnter: () => timeline.play()
    });
}
